import React, { FunctionComponent } from "react";
import { Text, View } from "@react-pdf/renderer";

type Props = { user: User };

const CustomerHeader: FunctionComponent<Props> = ({ user }) => {
  if (!user || !user.name) return null;

  return (
    <View
      fixed
      style={{
        borderBottom: "0.3px solid #303243",
        display: "flex",
        flexDirection: "row",
        alignItems: "baseline",
      }}
    >
      <Text style={{ fontSize: "8px", fontFamily: "Mont-Regular" }}>
        CLIENTE
      </Text>
      <Text
        style={{
          fontFamily: "PlayfairDisplay",
          marginLeft: "14px",
          fontSize: "12px",
          marginRight: "14px",
        }}
      >
        {user.name} {user.lastName ? user.lastName : ""}
      </Text>
      {user.companyName ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <Text
            style={{
              fontSize: "8px",
              fontFamily: "Mont-Regular",
            }}
          >
            RAZON SOCIAL
          </Text>
          <Text
            style={{
              fontFamily: "PlayfairDisplay",
              marginLeft: "14px",
              fontSize: "12px",
              position: "relative",
              bottom: "3px",
            }}
          >
            {user.companyName}
          </Text>
        </div>
      ) : null}
    </View>
  );
};

export default CustomerHeader;
